import { ButtonConfig } from '@zipari/shared-ds-util-button';
import { Datagrid } from '@zipari/shared-ds-util-datagrid';
import { AllControlsConfiguration } from '@zipari/shared-ds-util-form';
import { ActionButtonMetaConfig } from '../../notes/action-button/action-button.constants';
import { PaginatorConfiguration } from '../../notes/paginator/paginator.component';

export interface ListViewTab {
  datagrid?: Datagrid;
  description?: string;
  export?: ButtonConfig;
  filters?: {
    title?: string;
    description?: string;
    controls: AllControlsConfiguration[];
  };
  paginator?: PaginatorConfiguration;
}

export interface ListViewConfiguration {
  datagrid?: Datagrid;
  dataIsLoading: boolean;
  description?: string;
  export?: ButtonConfig;
  exportDropdown?: ActionButtonMetaConfig;
  filters?: {
    title?: string;
    description?: string;
    controls: AllControlsConfiguration[];
  };
  notes: string;
  paginator?: PaginatorConfiguration;
  tabs?: {
    allTabs: ListViewTab[];
    activeTab?: ListViewTab;
    tabLabels: string[];
  };
  title: string;
  isTitleWithMobileSearch?: boolean;
  datagridDescription?: string;
}
